module.exports = __webpack_public_path__ + "img/12_7.620e2039.png";